import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useInternetConnection } from '@connect-x-app/shared-utils';
import { toastError } from '@connect-x-app/web-ui';

export const useOnlineCallback = <A extends unknown[], R>(callback: (...args: A) => R, action: string) => {
  const { isInternetConnectionOffline } = useInternetConnection();
  const { t } = useTranslation();

  return useCallback(
    (...args: A): R | undefined => {
      if (isInternetConnectionOffline) {
        toastError(t('OFFLINE.ERROR.MESSAGE', { action: t(action) }));
        return;
      }
      return callback(...args);
    },
    [action, callback, isInternetConnectionOffline, t],
  );
};
